
const recentDevelopments = [
  {
    title: "Nvidia Unveils New AI Superchip for Data Centers",
    date: "June 2025",
    description: "Nvidia announced its next-gen AI superchip designed to deliver higher efficiency for large-scale data centers and generative AI.",
    url: "https://nvidianews.nvidia.com/news/nvidia-launches-ai-first-dgx-personal-computing-systems-with-global-computer-makers",
    color: "#8db8ff",
  },
  {
    title: "PepsiCo Rolls Out Reusable Packaging Pilot",
    date: "June 2025",
    description: "PepsiCo launched a new pilot program for reusable packaging in select US cities to cut single-use plastic waste.",
    url: "https://www.pepsico.com/our-impact/esg-topics-a-z/packaging",
    color: "#8dffb8",
  },
  {
    title: "AstraZeneca Wins FDA Approval for Rare Disease Drug",
    date: "July 2025",
    description: "AstraZeneca secured FDA approval for its new treatment for a rare genetic disorder, expanding its specialty care portfolio.",
    url: "https://www.biospace.com/astrazeneca-gets-fda-approval-in-boost-to-blockbuster-rare-disease-franchise",
    color: "#ff8d8d",
  },
  {
    title: "Adidas Introduces Fully Biodegradable Sportswear Line",
    date: "June 2025",
    description: "Adidas unveiled a new sportswear collection made entirely from biodegradable materials to support its circular fashion goals.",
    url: "https://www.adidas-group.com/en/media/press-releases/adidas-unveils-worlds-first-performance-shoe-made-from-biosteelr-fiber",
    color: "#ffc18d",
  },
  {
    title: "Chevron Announces Carbon Capture Facility in Australia",
    date: "July 2025",
    description: "Chevron revealed plans for a large-scale carbon capture and storage project in Western Australia to help cut emissions.",
    url: "https://www.chevron.com/newsroom/2023/q3/chevron-to-fund-new-soil-carbon-capture-pilot-and-blue-carbon-research-projects-in-western-australia",
    color: "#c18dff",
  },
  {
    title: "Hyundai Begins Production of New EV SUV in Europe",
    date: "June 2025",
    description: "Hyundai started production of its new all-electric SUV at its Czech Republic plant to meet European EV demand.",
    url: "https://www.hyundai.news/eu/articles/press-releases/all-new-kona-electric-begins-production-in-czech-republic.html",
    color: "#fff78d",
  },
];

export default recentDevelopments;
